import clsx from "clsx";
import { Col, Form, Pagination, Row } from "react-bootstrap";
import _ from "lodash";
import Table from "react-bootstrap/Table";
import * as setOffSelectors from "../../../../selectors/set-off";
import constants from "../../../../constants";
import EmptyItemView from "../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import React from "react";
import * as ipoSelectors from "../../../../selectors/ipo";
import { getSubscribedIPODetailsTotalAmountAppliedText } from "../../../../selectors/ipo";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons";

function EIPOHistoryTable({ data, onClickView, onClickDelete, page, setPage }) {
  const datalisting = _.get(data, ["data", "data"], []);
  const loading = _.get(data, ["isFetching"], false);
  const lastPage = _.get(data, ["data", "meta", "last_page"], null);
  return (
    <div className={"responsive-table-border table-w-1400 mt-3 position-relative"}>
      <Table responsive="lg">
        <thead>
          <tr className={"custom-table-setoff-styled"}>
            <th style={{ minWidth: 100 }}>Date/Time</th>
            <th style={{ minWidth: 100 }}>Share Name</th>
            <th style={{ minWidth: 120 }}>Price Per Share</th>
            <th style={{ minWidth: 140 }}>Number of Units</th>
            <th style={{ minWidth: 150 }}>Total Amount (RM)</th>
            <th style={{ minWidth: 100 }}>Status</th>
            <th style={{ minWidth: 120 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(datalisting) ? (
            _.map(datalisting, (item, index) => {
              const statusText = setOffSelectors.getSetOffStatusText(item);
              const statusValue = setOffSelectors.getSetOffStatusValue(item);
              const id = setOffSelectors.getSetOffID(item);
              const transactionAmount =
                setOffSelectors.getSetOffTransactionAmountFullText(item);
              const isCancellable =
                setOffSelectors.getSubmittedContractIsCancellable(item);
              const cancelLink =
                setOffSelectors.getSubmittedContractCancelLink(item);
              const transactionDate =
                setOffSelectors.getSubmittedTransactionDateTime(item);
              const ipo = setOffSelectors.getSubmittedIPO(item);
              const stockName = ipoSelectors.getIPODetailStockName(ipo);
              const pricePerShare =
                ipoSelectors.getIPODetailPricePerShare(item);
              const finalPricePerShare =
                  ipoSelectors.getIPODetailFinalPricePerShare(item);
              const priceChanged = ipoSelectors.getIPODetailPriceChanged(item);
              const numberOfShareAppliedText =
                ipoSelectors.getSubscribedIPODetailsNumberOfShareAppliedText(
                  item,
                );
              const totalAmountAppliedText =
                ipoSelectors.getSubscribedIPODetailsTotalAmountAppliedText(
                  item,
                );
              return (
                <tr key={index}>
                  <td>{transactionDate}</td>
                  <td>{stockName}</td>
                  <td>
                    <span>{pricePerShare}</span>
                    {priceChanged ? (
                        <span className="text-success ms-1" style={{ fontSize: "10px" }}>
                          <FontAwesomeIcon icon={faArrowDown}/>
                          <span>{finalPricePerShare}</span>
                        </span>
                    ) : false}
                  </td>
                  <td>{numberOfShareAppliedText}</td>
                  <td>{totalAmountAppliedText}</td>
                  <td>
                    <span
                      className={clsx("status-span", {
                        // ["pending-color"]: ,
                        ["successful-color"]:
                          statusValue === constants.STATUS_SUBMITTED ||
                          statusValue === constants.STATUS_PENDING,
                        ["error-color"]:
                          statusValue === constants.STATUS_REJECTED ||
                          statusValue === constants.STATUS_REQUEST_CANCEL ||
                          statusValue === constants.STATUS_CANCEL_SUBMITTED ||
                          statusValue === constants.STATUS_CANCELLED_CONFIRMED,
                      })}
                    >
                      {statusText}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex">
                      <button
                        className={clsx("btn custom-button-grey me-2")}
                        onClick={() => onClickView(id)}
                      >
                        View
                      </button>
                      {isCancellable ? (
                        <button
                          className={clsx(
                            "btn custom-button-white small long mx-2",
                          )}
                          onClick={(e) => {
                            e.preventDefault();
                            onClickDelete(cancelLink);
                          }}
                          disabled={!isCancellable}
                        >
                          Cancel
                        </button>
                      ) : (
                        false
                      )}
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={7}>
                <EmptyItemView />
              </td>
            </tr>
          )}
        </tbody>
        <tfoot className="epayment-table-footer">
          <tr>
            <td colSpan={7}>
              {lastPage > 1 ? (
                <div className={clsx("d-flex justify-content-center")}>
                  <Pagination
                    className="mt-2"
                    onClick={(e) => {
                      if (
                        _.toInteger(e.target.text) !== 0 &&
                        _.toInteger(e.target.text) !== page
                      ) {
                        setPage(_.toInteger(e.target.text));
                      }
                    }}
                  >
                    {_.times(lastPage, (index) => {
                      return (
                        <Pagination.Item
                          key={index + 1}
                          active={page === index + 1}
                        >
                          {index + 1}
                        </Pagination.Item>
                      );
                    })}
                  </Pagination>
                </div>
              ) : (
                false
              )}
            </td>
          </tr>
        </tfoot>
      </Table>
      <LoadingOverlay loading={loading}></LoadingOverlay>
    </div>
  );
}

export default EIPOHistoryTable;
